/* Somnora: reveal-on-scroll via IntersectionObserver (no scroll listeners). */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.s-reveal').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
  function scan(root) { (root || document).querySelectorAll('.s-reveal:not(.is-in)').forEach(function (el) { io.observe(el); }); }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();

/* Somnora: cart drawer add-on (AJAX add, re-render Dawn drawer). */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-s-upsell]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true; btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.sUpsell), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (drawer && state.sections && typeof drawer.renderContents === 'function') {
        state.id = Number(btn.dataset.sUpsell);
        drawer.renderContents(state);
      } else { window.location.href = '/cart'; }
    }).catch(function () { window.location.href = '/cart'; });
  });
})();
